<section class="hero">
  <div class="hero-content">
    <div class="text-content">
      <h1 class="hero-title">
        Connecting Tourists<br>
        with <span class="highlight">Trusted Guides.</span>
      </h1>
      <p class="hero-description">
        Safroo makes exploring easy. Tourists can discover authentic experiences, 
        while local guides can showcase their services - all in one platform.
      </p>
      <div class="app-buttons">
       
        <a href="#" class="download-btn app-store" aria-label="Download on App Store">
          <img src="assets/Home/AppleIcon.png" alt="Apple" class="store-icon" />
          <div class="btn-text">
            <span class="small-text">Download on the</span>
            <span class="large-text">App Store</span>
          </div>
        </a>
        <a href="#" class="download-btn play-store" aria-label="Get it on Google Play">
          <img src="assets/Home/PlaystoreIcon.png" alt="Google Play" class="store-icon" />
          <div class="btn-text">
            <span class="small-text">GET IT ON</span>
            <span class="large-text">Google Play</span>
          </div>
        </a>
   

      </div>
    </div>
    <div class="phone-mockup">
      <img src="assets/MobilePhones.png" alt="Safroo Mobile App" class="phones-image" />
    </div>
  </div>
</section>

<!-- About Safroo Section -->
<section class="about-section">
  <div class="about-container">
    <div class="image-grid">
      <div class="grid-item grid-item-1">
        <img src="assets/Home/LakeGirl.png" alt="Travel Experience" />
      </div>
      <div class="grid-item grid-item-2">
        <img src="assets/Home/girlswithredcar.png" alt="Group Travel" />
      </div>
      <div class="grid-item grid-item-3">
        <img src="assets/Home/girlswithmap.png" alt="Travel Planning" />
      </div>
      <div class="grid-item grid-item-4">
        <img src="assets/Home/island.png" alt="Beautiful Destination" />
      </div>
    </div>
    <div class="about-content">
      <span class="badge">About Safroo</span>
      <h2 class="section-title">
        Born from a Vision to<br>
        <span class="highlight">Transform Travel</span>
      </h2>
      <p class="section-description">
        Safroo was born with a vision to make travelling more personal and meaningful. 
        We connect travellers with passionate local guides who bring culture, history & 
        authentic stories to life.
      </p>
      <p class="section-description">
        Whether it's a hidden café in Paris, a mountain trek in Nepal, or a cultural 
        immersion in Tokyo, Safroo ensures you don't just visit - you truly experience. 
        Our platform bridges the gap between curious travellers & knowledgeable locals, 
        creating connection that lasts lifetime.
      </p>
      <div class="action-buttons">
        <button class="btn btn-primary">Learn More About Us</button>
        <button class="btn btn-secondary">Our Mission</button>
      </div>
    </div>
  </div>
</section>

<!-- Gradient Background Wrapper for Multiple Sections -->
<div class="gradient-sections-wrapper">
  
  <!-- How Safroo Works Section -->
  <section class="how-it-works">
    <h2 class="section-title-center">How Safroo Works</h2>
    <p class="section-subtitle">
      From discovery to unforgettable memories, we've made the entire process seamless and enjoyable.
    </p>
    
    <div class="steps-container">
      <div class="step-card">
        <div class="step-icon search-icon">
         <img src="assets/Home/search.png" alt="Search Icon" />
        </div>
        <h3 class="step-title">Search Destinations</h3>
        <p class="step-description">
          Browse tours and Guides in your travel location. Filter by interests, budget and experience type.
        </p>
      </div>

      <div class="step-card">
        <div class="step-icon guide-icon">
       <img src="assets/Home/user.png" style="height: 42px;"  alt="Guide Icon" />
        </div>
        <h3 class="step-title">Choose Your Guide</h3>
        <p class="step-description">
          View detailed profiles, read reviews, and select the right guide who matches your travel style.
        </p>
      </div>

      <div class="step-card">
        <div class="step-icon chat-icon">
        <img src="assets/Home/chat.png" alt="Chat Icon" />
        </div>
        <h3 class="step-title">Connect & Plan</h3>
        <p class="step-description">
          Chat directly with guide to customize your experience. Discuss preferences, timing, and special requests.
        </p>
      </div>

      <div class="step-card">
        <div class="step-icon trip-icon">
        <img src="assets/Home/location.png" style="height: 42px;"  alt="Trip Icon" />
        </div>
        <h3 class="step-title">Enjoy Your Trip</h3>
        <p class="step-description">
          Travel with confidence and create lasting memories. Rate your experience and help future travellers.
        </p>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section -->
  <section class="why-choose-us">
    <div class="why-container">
      <div class="why-image">
        <img src="assets/Home/Maskgirl.png" alt="Travel with Safroo" />
      </div>
      <div class="why-content">
        <h2 class="section-title">
          Why Choose Safroo?
        </h2>
        <p class="section-description">
          Experience travel like never before with personalized guidance, authentic local experiences, 
          and seamless planning all in one platform.
        </p>

        <div class="features-list">
          <div class="feature-item">
            <div class="feature-icon">
              <img src="assets/Home/flight.png" alt="Flight" />
            </div>
            <div class="feature-text">
              <h3>Authentic Experiences</h3>
              <p>Connect with local guides who bring destinations to life with insider knowledge and cultural insights.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <img src="assets/Home/hotel.png" alt="Hotel" />
            </div>
            <div class="feature-text">
              <h3>Trusted & Verified</h3>
              <p>All guides are thoroughly vetted and reviewed by our community to ensure quality and safety.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <img src="assets/Home/bags.png" alt="Bags" />
            </div>
            <div class="feature-text">
              <h3>Flexible & Personalized</h3>
              <p>Customize your itinerary, communicate directly, and travel at your own pace with dedicated support.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Your Journey Begins Section -->
  <section class="journey-section">
    <div class="journey-container">
      <div class="journey-content">
        <span class="badge">Experience</span>
        <h2 class="section-title">
          Your journey <span class="highlight-white">begins with<br>Safroo</span>
        </h2>
        <p class="section-description">
          We're redefining how people explore the world. Even though we're just getting started, 
          our goal is to make every journey smarter, smoother, and more memorable.
        </p>

        <div class="stats-grid">
          <div class="stat-card">
            <h3 class="stat-number">12k+</h3>
            <p class="stat-label">Successful trips</p>
          </div>
          <div class="stat-card">
            <h3 class="stat-number">2K+</h3>
            <p class="stat-label">Regular Clients</p>
          </div>
          <div class="stat-card">
            <h3 class="stat-number">10</h3>
            <p class="stat-label">Year Experience</p>
          </div>
        </div>
      </div>

      <div class="journey-image">
        <img src="assets/Home/manwithbags.png" alt="Travel with Safroo" />
        <div class="floating-badge location-badge">
          <span>Los Angeles</span>
        </div>
        <div class="floating-badge explore-badge">
          <span>Explore the World</span>
          <img src="assets/Home/groupboys.png" alt="Travelers" class="group-avatar" />
        </div>
      </div>
    </div>
  </section>

  <!-- Redefining Travel Experience Section -->
  <section class="redefine-section">
    <div class="redefine-container">
      <h2 class="section-title-center">
        Redefining <span class="highlight">Travel Experience.</span>
      </h2>
      <p class="section-subtitle">
        Connect with expert local guides and unlock unforgettable adventures. 
        Explore unique destinations, book personalized tours, and seamlessly manage your journey.
      </p>

      <div class="cta-buttons">
        <button class="btn btn-primary">Find Your Next Adventure</button>
        <button class="btn btn-secondary">Become a Safroo Guide</button>
      </div>

      <div class="redefine-image">
        <img src="assets/Home/groupboys.png" alt="Group of travelers exploring together" />
      </div>
    </div>
  </section>

</div>

<!-- Client Testimonials Section -->
<section class="testimonials-section">
  <div class="testimonials-container">
    <h2 class="section-title-center">See What Our Clients Say About Us</h2>
    
    <div class="testimonial-carousel">
      <button class="carousel-btn prev-btn" (click)="previousTestimonial()" aria-label="Previous testimonial">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

      <div class="testimonial-card">
        <div class="client-image">
          <img [src]="testimonials[currentTestimonial].image" [alt]="testimonials[currentTestimonial].name" />
        </div>
        
        <div class="quote-icon">
          <img src="assets/Home/doubleQuatoes.png" alt="Quote" />
        </div>
        
        <p class="testimonial-text">{{ testimonials[currentTestimonial].text }}</p>
        
        <h4 class="client-name">- {{ testimonials[currentTestimonial].name }}</h4>
      </div>

      <button class="carousel-btn next-btn" (click)="nextTestimonial()" aria-label="Next testimonial">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>

    <div class="carousel-indicators">
      <span 
        *ngFor="let testimonial of testimonials; let i = index" 
        class="indicator" 
        [class.active]="i === currentTestimonial"
        (click)="goToTestimonial(i)">
      </span>
    </div>
  </div>
</section>

<!-- Take Safroo With You Everywhere Section -->
<section class="mobile-app-section">
  <div class="mobile-app-container">
    <div class="app-content">
      <h2 class="section-title-white">Take Safroo With You Everywhere</h2>
      <p class="section-description-white">
        Download our mobile app and access all your travel plans, connect with guide, 
        and discover new destinations on the go.
      </p>

      <div class="features-list-mobile">
        <div class="feature-item-mobile">
          <div class="feature-icon-mobile">
            <img src="assets/Home/mobile.svg" alt="Mobile" />
          </div>
          <span>Available on iOS & Android</span>
        </div>

        <div class="feature-item-mobile">
          <div class="feature-icon-mobile">
            <img src="assets/Home/sync.png" alt="Sync" />
          </div>
          <span>Sync across all your devices</span>
        </div>

        <div class="feature-item-mobile">
          <div class="feature-icon-mobile">
            <img src="assets/Home/headPhone.png" alt="Support" />
          </div>
          <span>24/7 Support</span>
        </div>
      </div>

      <div class="app-download-buttons">
        <a href="#" class="download-btn app-store" aria-label="Download on App Store">
          <img src="assets/Home/AppleIcon.png" alt="Apple" class="store-icon" />
          <div class="btn-text">
            <span class="small-text">Download on the</span>
            <span class="large-text">App Store</span>
          </div>
        </a>
        <a href="#" class="download-btn play-store" aria-label="Get it on Google Play">
          <img src="assets/Home/PlaystoreIcon.png" alt="Google Play" class="store-icon" />
          <div class="btn-text">
            <span class="small-text">GET IT ON</span>
            <span class="large-text">Google Play</span>
          </div>
        </a>
      </div>
    </div>

    <div class="app-mockup">
      <img src="assets/MobilePhones.png" alt="Safroo Mobile App" />
    </div>
  </div>
</section>
